import RoleLogin from "../auth/RoleLogin";

export default function BrokerLogin() {
  return (
    <RoleLogin
      role="broker"
      variant="broker"
      title="Broker sign in"
      lead="Supervision desk for your brokerage."
      successPath="/broker/dashboard"
      links={[
        { to: "/register?role=broker", label: "Create broker account" },
        { to: "/agent/login", label: "Agent login" },
        { to: "/login", label: "Buyer login" },
      ]}
    />
  );
}
